module.exports = __webpack_public_path__ + "static/media/sin_resultados.b30315fa.svg";